module.exports = __webpack_public_path__ + "static/media/auctionLogo.ce92ca82.jpg";